<template>
  <v-col cols="auto">
    <v-dialog max-width="1200">
      <template #activator="{ on, attrs }">
        <v-btn
          depressed
          color="primary"
          style="color: white"
          v-bind="attrs"
          v-on="on"
          @click="showParcelamentos()"
        >
          <v-icon class="mr-2">folder_open</v-icon>Meus parcelamentos
        </v-btn>
      </template>
      <template #default="dialog">
        <v-card>
          <v-toolbar
            color="primary"
            class="text-h6 elevation-0"
            dark
          >
            Meus Parcelamentos
          </v-toolbar>
          <section
            v-if="title == 'Parcelas'"
            class="ma-3"
          >
            <v-btn
              text
              color="primary"
              @click="showParcelamentos()"
            >
              <v-icon color="primary">arrow_back</v-icon>Voltar
            </v-btn>
            <p class="ml-5 mt-3">
              <strong>ID: {{ dadosParcelamentoSelected.id }}</strong>
            </p>
            <section class="ma-5 d-flex flex-wrap">
              <section
                class="d-flex justify-space-between"
                style="width: 100%"
              >
                <p class="pa-0 ma-0 mr-2">
                  <strong>Contribuinte:</strong>
                  {{ dadosParcelamentoSelected.contribuinte.nomeRazaoSocial }} /
                  {{ dadosParcelamentoSelected.contribuinte.cpfCnpj | cnpjCpf }}
                </p>

                <p class="pa-0 ma-0">
                  <strong>Tipo parcelamento:</strong>
                  {{ dadosParcelamentoSelected.tipoParcelamento }}
                </p>
              </section>
              <section
                class="d-flex justify-space-between"
                style="width: 100%"
              >
                <p class="pa-0 ma-0">
                  <strong>Total de parcelas:</strong>
                  {{ dadosParcelamentoSelected.numeroParcelas }}
                </p>
                <p class="pa-0 ma-0 text-center">
                  <strong>Valor Total:</strong>
                  {{ dadosParcelamentoSelected.valorTotal | monetary }}
                </p>
              </section>

              <p
                class="pa-0 ma-0"
                style="width: 100%"
              >
                <strong>Data Negociação:</strong>
                {{ formatDate(dadosParcelamentoSelected.dataCadastro) }}
              </p>
              <SimularQuitacaoDialog
                v-if="canQuitar"
                :id-receita="dadosParcelamentoSelected.id"
                :cpf-cnpj="dadosParcelamentoSelected.contribuinte.cpfCnpj"
                :parcelas="revenueNegotiation.items"
                @updateReceita="updateParcelas()"
              />
            </section>
            <v-divider />
          </section>
          <v-container class="px-8">
            <v-alert
              v-if="showFirstInstallmentWarning"
              type="info"
              text
              border="left"
              color="primary"
              class="mb-4"
            >
              <strong>Atenção:</strong> As demais parcelas só serão liberadas
              após a confirmação do pagamento da primeira parcela.
            </v-alert>
            <DetailsQuitacaoDialog
              :dados-parcelamento="dadosParcelamentoSelected"
              :parcelas="revenueNegotiation.items"
            />
          </v-container>
          <v-card-text>
            <div
              v-if="!loader"
              class="pa-3"
            >
              <p class="ma-0 mx-0 text-h6">
                {{ title }}
              </p>
              <v-data-table
                v-model="revenueNegotiation.selected"
                :style="{
                  border: '0.01px #bebdbd solid',
                  cursor: title == 'Parcelamentos' ? 'pointer' : 'default',
                }"
                :headers="headers"
                :items="revenueNegotiation.items"
                :loading="revenueNegotiation.loading"
                :options.sync="paginationAptas"
                :footer-props="{
                  showFirstLastPage: true,
                  showCurrentPage: true,
                }"
                :item-class="rowClass"
                @click:row="onRowClick"
              >
                <template #item.numeroParcelas="{ item }">
                  {{ item.numeroParcelas }}
                  / {{ dadosParcelamentoSelected.numeroParcelas }}
                </template>
                <template #item.valorTotal="{ item }">
                  R$ {{ item.valorTotal | monetary }}
                </template>
                <template #item.competencia="{ item }">
                  {{ formatDateMesAno(item.competencia) }}
                </template>
                <template #item.dataCadastro="{ item }">
                  {{ formatDate(item.dataCadastro) }}
                </template>
                <template #item.dataVencimento="{ item }">
                  {{ formatDate(item.dataVencimento) }}
                </template>
                <template #item.dataPagamento="{ item }">
                  {{ formatDate(item.dataPagamento) }}
                </template>
                <template #item.grupoReceitaStatus="{ item }">
                  <v-chip
                    dark
                    :color="colorChips[item?.grupoReceitaStatus] ? colorChips[item?.grupoReceitaStatus] : 'grey lighten-1'"
                    small
                  >
                    {{
                      personalizarStatusParcela(item.grupoReceitaStatus)
                        ? personalizarStatusParcela(item.grupoReceitaStatus).text
                        : item.grupoReceitaStatus
                    }}
                  </v-chip>
                </template>
                <template #item.receitaStatus="{ item }">
                  <v-chip
                    dark
                    :color="colorChips[item.receitaStatus] ? colorChips[item.receitaStatus] : 'grey lighten-1'"
                    small
                  >
                    {{
                      personalizarStatusParcela(item.receitaStatus)
                        ? personalizarStatusParcela(item.receitaStatus).text
                        : item.receitaStatus
                    }}
                  </v-chip>
                </template>
                <template #item.acoes="{ item }">
                  <div v-if="title == 'Parcelas'">
                    <DialogBaixarDae
                      :ref="`dae-${item.id}`"
                      :id-receita="item.id"
                      :cpf-cnpj="dadosParcelamentoSelected.contribuinte.cpfCnpj"
                      :status="item.receitaStatus"
                      :data-vencimento="item.dataVencimento"
                    />
                  </div>
                  <v-tooltip
                    v-else
                    top
                  >
                    <template #activator="{ on, attrs }">
                      <v-icon
                        v-if="
                          item.grupoReceitaStatus === 'EM_ABERTO' ||
                            item.grupoReceitaStatus === 'QUITACAO_ANTECIPADA'
                        "
                        style="cursor: pointer"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="showParcelas(item)"
                      >request_quote</v-icon>
                    </template>
                    <span>Ver Parcelas</span>
                  </v-tooltip>
                </template>
              </v-data-table>

              <template v-if="title === 'Parcelas' && receitasAssociadas.length">
                <p class="ma-0 mx-0 text-h6 mt-6">
                  Receitas que geraram o parcelamento
                </p>
                <v-data-table
                  style="border: 0.01px #bebdbd solid"
                  :headers="headersReceitas"
                  :items="receitasAssociadas"
                  :footer-props="{
                    showFirstLastPage: true,
                    showCurrentPage: true,
                  }"
                >
                  <template #item.valorTotal="{ item }">
                    R$ {{ item.valorTotal | monetary }}
                  </template>
                  <template #item.competencia="{ item }">
                    {{ formatDateMesAno(item.competencia) }}
                  </template>
                  <template #item.dataCadastro="{ item }">
                    {{ formatDate(item.dataCadastro) }}
                  </template>
                  <template #item.receitaStatus="{ item }">
                    <v-chip
                      dark
                      :color="colorChips[item.receitaStatus] ? colorChips[item.receitaStatus] : 'grey lighten-1'"
                      small
                    >
                      {{
                        personalizarStatusParcela(item.receitaStatus)
                          ? personalizarStatusParcela(item.receitaStatus).text
                          : item.receitaStatus
                      }}
                    </v-chip>
                  </template>
                </v-data-table>
              </template>
            </div>
            <div
              v-else
              class="mt-5 d-flex justify-center"
            >
              <section
                class="d-flex flex-column align-center pa-10"
                style="background-color: #f3f3f3; border-radius: 10px"
              >
                <v-progress-circular
                  :size="50"
                  :width="5"
                  color="primary"
                  indeterminate
                  class="mb-3"
                />
                <strong>Carregando..</strong>
              </section>
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
              text
              @click="(dialog.value = false), showParcelamentos()"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-col>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import { monetaryFormat, cnpjCpfFormat } from "@/util/filters";
import { RevenueStatusList } from "@/models/financeiro/enum/revenue-status.enum";
import newNegociationService from "@/services/financeiro/new-negociation.service";
import SimularQuitacaoDialog from "./components/SimularQuitacaoDialog.vue";
import DialogBaixarDae from "./components/DialogBaixarDae.vue";
import DetailsQuitacaoDialog from "./components/DetailsQuitacaoDialog.vue";

const global = mapState("global", ["userGessan"]);

export default {
  name: "MeusParcelamentos",
  components: { SimularQuitacaoDialog, DialogBaixarDae, DetailsQuitacaoDialog },
  props: {
    contribuinte: { type: String, default: "" },
  },
  filters: {
    monetary: monetaryFormat,
    cnpjCpf: cnpjCpfFormat,
  },
  data() {
    return {
      headers: [],
      revenueNegotiation: {
        items: [],
        loading: false,
        total: 0,
      },
      paginationAptas: {
        sortBy: ["id"],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5,
      },
      paginationParcelamento: {
        sortBy: ["id"],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5,
      },
      loader: false,
      title: "Parcelamentos",
      dadosParcelamentoSelected: null,
      receitasAssociadas: [],
      headersReceitas: [
        { text: "ID", value: "id", sortable: false },
        { text: "Competência", value: "competencia", sortable: false },
        { text: "Data Criação", value: "dataCadastro", sortable: false },
        { text: "Valor", value: "valorTotal", sortable: false },
      ],
      colorChips: {
        EM_ABERTO: "primary lighten-1",
        PAGO: "green lighten-1",
        PARCELADO: "grey lighten-1",
        APURACAO: "grey lighten-1",
        JURIDICO: "grey lighten-1",
        DIVIDA_ATIVA: "grey lighten-1",
        CANCELADO: "red lighten-1",
        SUSPENSO: "red lighten-1",
        PRE_PARCELADO: "grey lighten-1",
        PARCELAMENTO_PERDIDO: "grey lighten-1",
        PRE_REPACELADO: "grey lighten-1",
        REPARCELADO: "grey lighten-1",
        REPARCELAMENTO_PERDIDO: "grey lighten-1",
        PRE_REREPARCELADO: "grey lighten-1",
        REREPARCELADO: "grey lighten-1",
        REREPARCELAMENTO_PERDIDO: "grey lighten-1",
      },
      canQuitar: false,
      receitaStatusBaixavel: [
        RevenueStatusList[0].value,
        RevenueStatusList[8].value,
        RevenueStatusList[13].value,
      ],
    };
  },
  computed: {
    ...global,
    showFirstInstallmentWarning() {
      if (this.title !== "Parcelas" || !this.revenueNegotiation.items?.length) {
        return false;
      }

      const sortedParcelas = [...this.revenueNegotiation.items].sort(
        (a, b) => a.numeroParcelas - b.numeroParcelas
      );
      const firstParcela = sortedParcelas[0];
      const preStatuses = ["PRE_PARCELADO", "PRE_REPARCELADO", "PRE_REREPARCELADO"];

      return firstParcela && preStatuses.includes(firstParcela.receitaStatus);
    },
  },
  methods: {
    showParcelamentos() {
      this.title = "Parcelamentos";
      this.receitasAssociadas = [];
      this.loader = true;
      this.headers = [
        { text: "ID", value: "id", sortable: false },
        {
          text: "Contribuinte",
          value: "contribuinte.nomeRazaoSocial",
          sortable: false,
        },
        { text: "Data da Negociação", value: "dataCadastro" },
        { text: "Valor", value: "valorTotal" },
        { text: "Tipo Parcelamento", value: "tipoParcelamento" },
        { text: "Status", value: "grupoReceitaStatus", width: "10%" },
        { text: "Observação", value: "observacao", width: "20%" },
        { text: "Ações", value: "acoes", align: "center" },
      ];

      newNegociationService
        .listParcelamentos(this.userGessan?.cnpj, {
          page: this.paginationParcelamento.page.toString(),
          size: this.paginationParcelamento.itemsPerPage.toString(),
          ascendingSort: this.paginationParcelamento.sortDesc[0].toString(),
          sort: this.paginationParcelamento.sortBy,
        })
        .subscribe(
          res => {
            this.loader = false;
            this.revenueNegotiation.items = res.content || [];
          },
          () => {
            this.loader = false;
          }
        );
    },
    showParcelas(item) {
      this.dadosParcelamentoSelected = item;
      this.title = "Parcelas";
      this.loader = true;
      this.paginationAptas = {
        sortBy: ["competencia"],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5,
      };
      this.headers = [
        { text: "Competência", value: "competencia", sortable: false },
        { text: "Data Criação", value: "dataCadastro", sortable: false },
        { text: "Data da Vencimento", value: "dataVencimento", sortable: false },
        { text: "Data Pagamento", value: "dataPagamento", sortable: false },
        { text: "Valor", value: "valorTotal", sortable: false },
        { text: "Status", value: "receitaStatus", sortable: false },
        { text: "Observação", value: "observacao", width: "20%", sortable: false },
        { text: "Parcelas", value: "numeroParcelas", align: "center", sortable: false },
        { text: "Ações", value: "acoes", align: "center" },
      ];

      newNegociationService.listParcelas(this.userGessan?.cnpj, item.id).subscribe(
        res => {
          this.revenueNegotiation.items = res.parcelamentos || [];
          this.canQuitar = this.checkIfCanQuitar(item.grupoReceitaStatus, this.revenueNegotiation.items);
          this.receitasAssociadas = res.receitas || [];
          this.loader = false;
        },
        () => {
          this.loader = false;
        }
      );
    },
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    },
    formatDateMesAno(date) {
      return date ? moment(date).format("MM/YYYY") : "";
    },
    personalizarStatusParcela(status) {
      return RevenueStatusList.find(s => s.value == status);
    },
    rowClass(item) {
      if (this.title !== "Parcelas") {
        return "";
      }

      return this.receitaStatusBaixavel.includes(item.receitaStatus) ? "row-baixavel" : "";
    },
    onRowClick(item) {
      if (this.title === "Parcelamentos") {
        this.showParcelas(item);
        return;
      }

      if (this.title === "Parcelas" && this.receitaStatusBaixavel.includes(item.receitaStatus)) {
        const ref = this.$refs[`dae-${item.id}`];
        const instance = Array.isArray(ref) ? ref[0] : ref;

        instance?.acionar();
      }
    },
    checkIfCanQuitar(status, parcelas) {
      return (
        status === RevenueStatusList[0].value && // Receita tem que está EM_ABERTO
        this.checkParcelaPaga(parcelas).receitaStatus === RevenueStatusList[1].value && // Primeira parcela tem que está PAGA
        this.dadosParcelamentoSelected.tipoParcelamento != RevenueStatusList[17].text
      );
    },
    checkParcelaPaga(parcelas) {
      return parcelas.find(e => e.receitaStatus == RevenueStatusList[1].value) || false;
    },
    updateParcelas() {
      this.showParcelas(this.dadosParcelamentoSelected);
    },
  },
};
</script>

<style scoped>
::v-deep .row-baixavel {
  cursor: pointer;
}
</style>
